
import $ from 'jquery';
import {findObjectById, getLocacion} from '../../util';



export class UsuarioCursoApi {
    
    static activar(id, token) {  
       return $.ajax({
            headers: {"Authorization": "Bearer " + token.idToken}, 
        	url: getLocacion()+ "/api/usuariocurso/activar/"+id,
			type: "PUT",
			statusCode: {
				401: function() {
				   // Only if your server returns a 403 status code can it come in this block. :-)
					window.location = getLocacion()+'/login';
				}
				
			}
		});
	}
    
    
     static borrar(id, token) {  
       return $.ajax({
            headers: {"Authorization": "Bearer " + token.idToken}, 
        	url: getLocacion()+ "/api/usuariocurso/"+id,
			type: "DELETE",
			statusCode: {
				401: function() {
				   // Only if your server returns a 403 status code can it come in this block. :-)
					window.location = getLocacion()+'/login';
				}
				
			}
		});
	}
    
    
    static getUsuarioCursoList(pagina, regitrosPorPagina, filtro, showActivos, filtrosCombo, token ) {
        
         return $.ajax({
            headers: {"Authorization": "Bearer " + token.idToken},  
			url: getLocacion()+ "/api/usuariocurso?page="+pagina+"&size="+regitrosPorPagina+"&filtro="+filtro+"&activos="+showActivos,
			statusCode: {
				401: function() {
				   // Only if your server returns a 403 status code can it come in this block. :-)
					window.location = getLocacion()+'/login';
				}
			}
		});
      
	}
    
    
    static getUsuarioCurso(id, token ) {  
         return $.ajax({
            headers: {"Authorization": "Bearer " + token.idToken},  
			url: getLocacion()+ "/api/usuariocurso/"+id,
			statusCode: {
				401: function() {
				   // Only if your server returns a 403 status code can it come in this block. :-)
					window.location = getLocacion()+'/login';
				}
			}
		});
        
	}
    
    
     static getUsuarioCursoPrevio(token ) {  
         return $.ajax({
            headers: {"Authorization": "Bearer " + token.idToken},  
			url: getLocacion()+ "/api/usuariocurso/previo/",
			statusCode: {
				401: function() {
				   // Only if your server returns a 403 status code can it come in this block. :-)
					window.location = getLocacion()+'/login';
				}
			}
		});
        
	}
    
    
    
    static save(usuariocurso, token ) {          
      let usuariocursoEnvio = Object.assign({}, usuariocurso);
		let comando="POST";
		if (usuariocursoEnvio.id > 0) {
			comando="PUT";			
		} 
		usuariocursoEnvio=JSON.stringify(usuariocursoEnvio);
		return $.ajax({
            headers: {"Authorization": "Bearer " + token.idToken},  
			url: getLocacion()+ "/api/usuariocurso/",
			type: comando,
			contentType: "application/json; charset=utf-8",
			dataType: "json",
			data: usuariocursoEnvio,
			statusCode: {
				401: function() {
				   // Only if your server returns a 403 status code can it come in this block. :-)
					window.location = getLocacion()+'/login';
				}
			}
		});
	}   
    
    
    
        static saveImagen(file, token ) {
		return $.ajax({
            headers: {"Authorization": "Bearer " + token.idToken},  
            url: getLocacion()+ "/api/usuariocurso/upload/constancia",
            contentType: false,
            processData: false,
            type: 'POST',
            data: file,
			statusCode: {
				401: function() {
				   // Only if your server returns a 403 status code can it come in this block. :-)					
					window.location = getLocacion()+'/login';
				}
			}
		});
	}
    
    
    static getUsuarioCursoCombo(token ) {

		return $.ajax({
 headers: {"Authorization": "Bearer " + token.idToken},  
			url: getLocacion()+ "/api/usuariocurso/combo/",
			statusCode: {
				401: function() {
				   // Only if your server returns a 403 status code can it come in this block. :-)
					window.location = getLocacion()+'/login';
				}
			}
		});
	}
    
     

    
}